import {
  EIntakeStep,
  IApplication,
} from "@rentiohq/shared-frontend/dist/types/application.types";
import {
  EContractLengthType,
  IContract,
} from "@rentiohq/shared-frontend/dist/types/contract.types";
import { EContractEndingStatus } from "./components/ContractCard/components/ContractStatusChip/contractStatusChip.types";

export const getContractDuration = (
  contract: IContract,
): EContractEndingStatus => {
  if (contract.dateOfCancellation) {
    return EContractEndingStatus.Cancelled;
  }

  if (contract.tacitRenewal) {
    if (contract.contractLengthType === EContractLengthType.Short) {
      return EContractEndingStatus.ShortTerm;
    }

    return EContractEndingStatus.LongTerm;
  }

  return EContractEndingStatus.AutoEnding;
};

export const getTenantsFromApplications = (applications?: IApplication[]) => {
  if (!applications) {
    return;
  }

  const tenantApplications = applications.filter(
    application => application.step === EIntakeStep.tenant,
  );

  if (tenantApplications.length === 0) {
    return;
  }

  const tenants = tenantApplications
    .map(application => application.contacts)
    .flat();

  return tenants;
};
